import React, { FunctionComponent } from 'react';
import { forEach } from 'ramda';
import moment from 'moment';

import { formatDate } from 'helpers/date';

type MonthsReference = {
  [index: string]: string;
};

type Data = {
  [key: string]: any;
};

type Props = {
  data: Data[];
  x?: number;
  y?: number;
  payload?: { value: string };
  xAxis?: string;
};

const getMonth = (date?: string) => moment.utc(date).format('MMM');

const getMonthPoints = (data: Data[], xAxis: string) => {
  const monthsReference: MonthsReference = {};

  forEach((row: Data) => {
    const value = row[xAxis];
    const month = getMonth(value);

    if (moment(monthsReference[month]).isAfter(value)) {
      monthsReference[month] = value;
    }
  }, data);

  return monthsReference;
};

const TickFormatter: FunctionComponent<Props> = ({
  x,
  y,
  data,
  payload,
  xAxis = 'periodStart',
}) => {
  const period = payload && formatDate(payload.value);
  const monthPoints = getMonthPoints(data, xAxis);
  const day = moment(period).format('DD');
  const month = getMonth(period);

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fill="#666" fontSize=".750rem">
        <tspan textAnchor="middle" x="0">
          {day}
        </tspan>

        {monthPoints[month] === period && (
          <tspan textAnchor="middle" x="0" dy="20">
            {month}
          </tspan>
        )}
      </text>
    </g>
  );
};

export default TickFormatter;
